import React from 'react';
import { Search, Plus, ArrowRight } from 'lucide-react';
import { Button, Badge } from '../ui';


import heroImage from '../../assets/images/hand.jpg';

const scrollToWaitlist = () =>
  document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth' });

const Hero = () => (
  <section className="relative overflow-hidden min-h-screen flex items-center">

    {/* Background */}
    <div className="absolute inset-0 z-0">
      <div className="w-full h-full bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${heroImage})` }} />
    </div>

    <div className="relative z-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
      <div className="text-center">

        <Badge className="mb-8">
          🚀 Coming Soon — Be the First to Connect
        </Badge>

        <div className="bg-black/30 backdrop-blur-sm rounded-2xl p-6 sm:p-8 mb-8 sm:mb-12 mx-auto max-w-6xl">
          <h1 className="text-3xl sm:text-5xl lg:text-7xl font-bold text-white leading-tight mb-6 drop-shadow-lg">
            Connect{' '}
            <span className="bg-gradient-to-r from-red-400 to-red-600 bg-clip-text text-transparent">
              Kitchens{' '}
            </span>
            with
            <span className="bg-gradient-to-r from-red-600 to-red-800 bg-clip-text text-transparent">
              {' '}Creators
            </span>
          </h1>
          <p className="text-base sm:text-xl lg:text-2xl text-gray-100 leading-relaxed max-w-4xl mx-auto">
            The revolutionary marketplace connecting food creators with professional kitchen spaces. Turn your culinary dreams into reality or monetize your unused kitchen capacity.
          </p>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center px-4">
          <Button size="lg" icon={Search} iconRight={ArrowRight} className="group min-w-[200px] w-full sm:w-auto" onClick={scrollToWaitlist}>
            Find a Kitchen
          </Button>
          <Button size="lg" variant="secondary" icon={Plus} iconRight={ArrowRight} className="group min-w-[200px] w-full sm:w-auto" onClick={scrollToWaitlist}>
            List Your Kitchen
          </Button>
        </div>

      </div>
    </div>
  </section>
);

export default Hero;
